module.exports = __webpack_public_path__ + "img/spinningwheel.e8604cd5.gif";